import { formatPullQuoteImage } from "../organism-formatting/feats/FormatAndRenderPullQuote"
import formatVideo from "./formatVideo"
import formatPageLinks from "./formatPageLinks"
import { Link } from "gatsby"

export const formatPullQuote = (
  quoteItem,
  data,
  locale,
  props,
  products,
  siteIdentifier
) => {
  const text = quoteItem?.quote?.quote
  const source = quoteItem?.author
  const sourceTitle = quoteItem?.authorCredentials
  const quote = { text, source, sourceTitle }
  const imagePosition = quoteItem?.imagePosition?.toString() || "Left"
  const appearance = quoteItem?.appearance || "Light"
  const imageOptions = quoteItem?.imageOptions || "1/2"
  const pullQuoteLottieStyles = {}
  const topImage = formatPullQuoteImage(
    quoteItem?.topImage,
    pullQuoteLottieStyles
  )
  const sideImage = formatPullQuoteImage(
    quoteItem?.sideImage,
    pullQuoteLottieStyles
  )
  const backgroundImage = formatPullQuoteImage(
    quoteItem?.backgroundImage,
    pullQuoteLottieStyles
  )
  const contentfulId = quoteItem?.contentfulId

  const linkType = quoteItem?.cta?.url?.contentType
    ? quoteItem?.cta?.url?.contentType
    : quoteItem?.cta?.url?.internal?.type
    ? quoteItem?.cta?.url?.internal?.type
    : null

  const cta = formatPageLinks(
    data?.cta,
    locale,
    linkType,
    null,
    props?.currentSpaceId,
    products,
    siteIdentifier
  )

  const theme =
    appearance === "Dark"
      ? {
          backgroundColor: "#252a2e",
          color: "#fff",
          ctaClass: "secondary--1",
        }
      : {
          backgroundColor: "#fff",
          color: "#252a2e",
          ctaClass: "primary--2",
        }

  if (cta) {
    cta.className = theme?.ctaClass
  }
  return {
    quote,
    cta,
    theme,
    Link,
    topImage,
    sideImage,
    imageOptions,
    imagePosition,
    appearance,
    backgroundImage,
    contentfulId,
  }
}
